module.exports = __webpack_public_path__ + "img/notice_报工处理.jpg";